import { Component } from '@angular/core';

@Component({
  selector: 'lib-planxgo',
  template: `
    <div class="planxgo-home">
      <h1>PlanXGo Dashboard</h1>
      <p>Contenido principal de PlanXGo.</p>
    </div>
  `,
  styles: [],
})
export class PlanxgoComponent {}
